import { RootState } from "../rootReducer"

export const selectGetRolesState = (state: RootState) => state.roles.roles
export const selectGetAllRoleSettingsState = (state: RootState) => state.roles.allRoleSettings
export const selectAllGlobalPermissionsState = (state: RootState) => state.roles.allGlobalPermissions
export const selectCreateRoleState = (state: RootState) => state.roles.createRole
export const selectUpdateRoleState = (state: RootState) => state.roles.updateRole
